export default __webpack_public_path__ + "static/media/rishikesh.f8bbd0fc.jpg";